/**
 * useWeather — fetches and caches weather data for airports.
 */
import { useState, useCallback, useRef } from 'react';
import { WebWeatherService, type WebWeatherData } from '../services/WebWeatherService';

export function useWeather() {
  const [data, setData] = useState<WebWeatherData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const serviceRef = useRef(new WebWeatherService());

  const fetchWeather = useCallback(async (stationId: string) => {
    setLoading(true); setError(null);
    try {
      const result = await serviceRef.current.fetchForStation(stationId);
      setData(result);
      return result;
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'Weather fetch failed';
      setError(msg);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchWeatherBbox = useCallback(async (
    minLat: number, maxLat: number, minLon: number, maxLon: number,
  ) => {
    setLoading(true); setError(null);
    try {
      const result = await serviceRef.current.fetchForBbox(minLat, maxLat, minLon, maxLon);
      setData(result);
      return result;
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'Weather fetch failed';
      setError(msg);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, error, fetchWeather, fetchWeatherBbox };
}
